import { external, production } from './environment.production'

export const environment = {
  ...production,
  ...external,
  adobeLaunchEnv: 'production',
  vfeURLPrefix: 'https://personal.vanguard.com/us/',
  compareURLPrefix: 'https://investor.vanguard.com/tools-calculators/etf-fund-comparison-tool?Ticker=',
  realEstateUrlPrefix:'http://personal.vanguard.com/us/',
  irrPrettyUrlEast1:
    'https://irr-investment-retail-rest-external.ecs.us-east-1.retp.c1.vanguard.com/',
  irrPrettyUrlWest2:
    'https://irr-investment-retail-rest-external.ecs.us-west-2.retp.c1.vanguard.com/',
  caasContentLongListURL:
    'https://api.ecs.us-east-1.essp.c1.vanguard.com/lci-ecs-content-adapter-webservice-prod/rest/public/content/pageid/VanguardFundsLongListPageId/project/VFA?env=prod-external',
  investorUrl: 'https://investor.vanguard.com',
  caasContentProfileURL:
    'https://api.ecs.us-east-1.essp.c1.vanguard.com/lci-ecs-content-adapter-webservice-prod/rest/public/content/pageid/VanguardFundsProfilePageId/project/VFA',
  etfDisclaimerLink:
    'https://investor.vanguard.com/investing/transaction-fees-commissions/etfs',
  pdfDisclaimerLink529:
    'https://personal.vanguard.com/pdf/529progdesc.pdf?cbdForceDomain=true',
  aemCaaSURL:
    'https://retaemdisp.retp.c1.vanguard.com/content/ret/funds/fundlist/public.caas.json',
  taxExemptLink:
    'https://investor.vanguard.com/investor-resources-education/mutual-funds/what-are-tax-exempt-funds',
  vfaPersonal1Url: 'https://personal1.vanguard.com/',
  externalUrl: 'https://personal.vanguard.com/',
  vgnHFUrl: 'https://n4v.web.vanguard.com',
  irePrettyUrlEast1: 'https://api.vanguard.com/rs/ire/01/'
}
